<div class="row col-12 p-0 m-0 forbidden-container main-page-section ">
  <div class="col-12 p-0">
    <!-- <app-header></app-header> -->
    <div class="forbidden-section row">
      <div class="col-4">
        <div class="forbidden-content">
          <p class="title">Access forbidden</p>
          <p class="description">You tried to access a page you did not
            have prior authorization for.</p>
          <p class="go-back" routerLink="/overview">Go Back to overview</p>
        </div>
      </div>
      <div class="col-8">
        <div class="forbidden-image">
          <div class="forbidden-image">
            <img src="../../../../../../assets/images/error-page/forbidden.svg" alt="forbidden image" loading="lazy" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
